import {SchemeLink} from '../../../../applink/SchemeLink';
import {getImageRatio} from '../../../../design-system/atoms/Image/getImageRatio.function';
import {Image} from '../../../../design-system/atoms/Image/Image';
import {EventBannerItem} from '../../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonItemProps} from '../../type';

export function EventBanner({item}: CommonItemProps) {
  const {thumbnail, title, scheme, eventLog} = item as EventBannerItem;
  return (
    <SchemeLink scheme={scheme || undefined}>
      <Image
        alt={title || '썸네일'}
        ratio={getImageRatio({width: 16, height: 9})}
        src={thumbnail}
        className="overflow-hidden rounded-3pxr"
        onClickCapture={e => LOG_CLICK_EVENT('빅배너_클릭', e)}
        {...putTiaraObjectProps(eventLog)}
      />
    </SchemeLink>
  );
}
